import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getSidebar, deleteSidebar, setActiveSidebar } from '../actions/SidebarActions';

import { 
    Pane, 
    Heading, 
    Button, 
    Badge, 
    Text, 
    Code, 
    Pre,
    ArrowLeftIcon,
    EditIcon,
    TickCircleIcon,
    TrashIcon
} from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';
import DeleteDialog from '../../common/DeleteDialog/DeleteDialog';

import { Link } from 'react-router-dom';

class ViewSidebar extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }

    componentDidMount() {
        this.props.dispatch(getSidebar(this.id));
    }

    handleDelete = () => {
        this.props.dispatch(deleteSidebar(this.id));
    }

    handleSetActive = () => {
        if (window.confirm('Esti sigur ca vrei sa activezi acest sidebar?')) {
            this.props.dispatch(setActiveSidebar(this.id));
        }
    }

    render() {
        const sidebar = this.props.sidebar || {};

        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex" alignItems="center">
                    <Pane>
                        <Link to="/sidebar">
                            <Button icon={ArrowLeftIcon} intent="none">
                                Inapoi la lista sidebar
                            </Button>
                        </Link>
                    </Pane>

                    <Pane marginLeft={16}>
                        <Link to={`/sidebar/${this.id}/edit`}>
                            <Button icon={EditIcon} intent="none" appearance="primary">
                                Editeaza
                            </Button>
                        </Link>
                    </Pane>

                    {!sidebar.active && (
                        <Pane marginLeft={16}>
                            <Button 
                                icon={TickCircleIcon} 
                                intent="success"
                                onClick={this.handleSetActive}
                            >
                                Seteaza ca Activ
                            </Button>
                        </Pane>
                    )}

                    {!sidebar.active && (
                        <Pane marginLeft="auto">
                            <DeleteDialog
                                onDelete={this.handleDelete}
                                title="Sterge Sidebar"
                                message="Esti sigur ca vrei sa stergi acest sidebar?">
                                <Button icon={TrashIcon} intent="danger">
                                    Sterge
                                </Button>
                            </DeleteDialog>
                        </Pane>
                    )}
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Pane display="flex" alignItems="center">
                        <Heading size={600}>
                            Sidebar: {sidebar.name}
                        </Heading>
                        {sidebar.active && (
                            <Badge color="green" marginLeft={16}>ACTIV</Badge>
                        )}
                    </Pane>
                </Pane>

                <Pane display="flex" marginTop={16} gap={16}>
                    <InfoBlock title="Informatii Generale" flex="1">
                        <Pane marginBottom={8}>
                            <Text size={300} color="muted">ID</Text>
                            <Text display="block">{sidebar.id}</Text>
                        </Pane>
                        <Pane marginBottom={8}>
                            <Text size={300} color="muted">Nume</Text>
                            <Text display="block">{sidebar.name}</Text>
                        </Pane>
                        <Pane marginBottom={8}>
                            <Text size={300} color="muted">Status</Text>
                            <Pane>
                                {sidebar.active ? 
                                    <Badge color="green">Activ</Badge> : 
                                    <Badge color="neutral">Inactiv</Badge>
                                }
                            </Pane>
                        </Pane>
                        <Pane marginBottom={8}>
                            <Text size={300} color="muted">Creat</Text>
                            <Text display="block">{new Date(sidebar.createdAt).toLocaleString('ro-RO')}</Text>
                        </Pane>
                        <Pane marginBottom={8}>
                            <Text size={300} color="muted">Modificat</Text>
                            <Text display="block">{new Date(sidebar.updatedAt).toLocaleString('ro-RO')}</Text>
                        </Pane>
                    </InfoBlock>

                    <InfoBlock title="Definitie (JSON)" flex="2">
                        <Pre 
                            fontFamily="mono" 
                            fontSize={12}
                            overflow="auto"
                            maxHeight={500}
                            background="tint2"
                            padding={16}
                            borderRadius={4}
                        >
                            {JSON.stringify(sidebar.definition, null, 2)}
                        </Pre>
                    </InfoBlock>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        sidebar: state.sidebar.current
    }
}

export default connect(mapStateToProps)(ViewSidebar);
